import { render } from "./ChildProduct.vue?vue&type=template&id=4c7a311c&scoped=true"
import script from "./ChildProduct.vue?vue&type=script&lang=js"
export * from "./ChildProduct.vue?vue&type=script&lang=js"

import "./ChildProduct.vue?vue&type=style&index=0&id=4c7a311c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7a311c"]])

export default __exports__